import _ from "underscore";

import Modal from "shared/modal";
import Ajax from "shared/ajax";

import Toast from "shared/toast";

export default class DeleteVirtualLineModal extends Modal {
  initialize({ row, deleteUrl }) {
    this.row = row;
    this.deleteUrl = deleteUrl;
    this.subtitle = this.row.model.escape('promo_number');
  }

  body() {
    return "Are you sure you want to permanently delete this Promo Number?\nCallers will hear an \"out of service\" message.";
  }

  _onDelete() {
    const modal = this;
    const row = modal.row;
    const model = row.model;
    const table = row.parent;

    model.sync('delete', model, {
      url: modal.deleteUrl,
      success() {
        table.reload();
        modal.close();
        Toast.success("Successfully deleted promo number");
      },
      error(xhr, status, error) { // TODO: dry up error handling logic
        const parsedResponse = Ajax.parseResponse(xhr);
        Toast.error(parsedResponse.message);
        modal.close();
      }
    });
  }
}

_.extend(DeleteVirtualLineModal.prototype, {
  title: "Delete Promo Number",

  buttons: [
    {
      text: "Cancel",
      className: 'btn-secondary',
      close: true
    },
    {
      click() {
        const modal = this.parent;
        modal._onDelete();
      },
      text: "Okay",
      className: 'btn-primary'
    }
  ]
});
